import React from "react";
import Input from "./input";
// import Select from "./select";
import SingleSelect from "./singleSelect";
import Radio from "./radio";
import Checkbox from "./checkbox";
import ReactSelect from "./reactSelect";
import CheckBoxGroup from "./reactCheckBoxGroup";

function Controler(props){
    const {control, handleChange, hendleDefaultCheck, isMandatory,formikValues, ...rest} = props
    
    switch (control) {
        case 'input':
             return <Input handleChange={handleChange} {...rest} />
        case 'checkbox':
            return <Checkbox handleChange={handleChange} formikValues={formikValues} isMandatory={isMandatory} {...rest} />     
        case 'radio':
            return <Radio handleChange={handleChange} isMandatory={isMandatory} {...rest} />
        case 'textarea':  
        case 'select':
            return <SingleSelect {...props} />
        case 'react_select':
            return <ReactSelect handleChange={handleChange} formikValues={formikValues} hendleDefaultCheck={hendleDefaultCheck} {...rest} />
        case 'checkboxGroup':
            return <CheckBoxGroup handleChange={handleChange} isMandatory={isMandatory} {...rest} />

        default: return null  
    }


}
export default Controler